import {
  faBluesky,
  faFacebook,
  faInstagram,
  faPatreon,
  faTiktok,
  faTwitch,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import {
  faAngleRight,
  faArrowDown,
  faArrowDown19,
  faArrowDownWideShort,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBan,
  faBoltLightning,
  faBook,
  faC,
  faCalendar,
  faCaretDown,
  faChartSimple,
  faCheck,
  faChessBoard,
  faChessKing,
  faChessQueen,
  faChessRook,
  faCircle,
  faCircleExclamation,
  faCircleQuestion,
  faClock,
  faClone,
  faCog,
  faCoins,
  faCrown,
  faDollarSign,
  faEllipsisV,
  faEnvelope,
  faExclamation,
  faEye,
  faFilter,
  faFire,
  faFireFlameSimple,
  faFont,
  faGear,
  faGem,
  faHand,
  faHandshake,
  faHashtag,
  faHatCowboy,
  faHeart,
  faHourglass,
  faHourglassEnd,
  faHourglassHalf,
  faHourglassStart,
  faHouse,
  faImage,
  faInfinity,
  faLandmark,
  faLink,
  faListCheck,
  faLock,
  faM,
  faMagnifyingGlass,
  faMinus,
  faMoneyBillWave,
  faMoon,
  faNewspaper,
  faPaperclip,
  faPeopleArrows,
  faPercent,
  faPlus,
  faPodcast,
  faQuestion,
  faR,
  faRandom,
  faRotateLeft,
  faRotateRight,
  faRoute,
  faRssSquare,
  faS,
  faSackDollar,
  faScroll,
  faSearch,
  faShirt,
  faSkullCrossbones,
  faSquareMinus,
  faSquarePlus,
  faStar,
  faStethoscope,
  faStopwatch,
  faSun,
  faTable,
  faTableCellsLarge,
  faTableList,
  faTag,
  faThumbsUp,
  faTimes,
  faTrash,
  faU,
  faUnlock,
  faUser,
  faWandMagicSparkles,
  faWrench,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

const EDHREC_ICONS = {
  angleRight: faAngleRight,
  arrowDown: faArrowDown,
  arrowDown19: faArrowDown19,
  arrowDownWideShort: faArrowDownWideShort,
  arrowLeft: faArrowLeft,
  arrowRight: faArrowRight,
  arrowUp: faArrowUp,
  ban: faBan,
  bluesky: faBluesky,
  boltLightning: faBoltLightning,
  book: faBook,
  c: faC,
  calendar: faCalendar,
  caretDown: faCaretDown,
  chartSimple: faChartSimple,
  check: faCheck,
  chessBoard: faChessBoard,
  chessKing: faChessKing,
  chessQueen: faChessQueen,
  chessRook: faChessRook,
  circle: faCircle,
  circleExclamation: faCircleExclamation,
  circleQuestion: faCircleQuestion,
  clock: faClock,
  clone: faClone,
  cog: faCog,
  coins: faCoins,
  crown: faCrown,
  dollarSign: faDollarSign,
  ellipsisV: faEllipsisV,
  envelope: faEnvelope,
  exclamation: faExclamation,
  eye: faEye,
  facebook: faFacebook,
  filter: faFilter,
  fire: faFire,
  fireFlameSimple: faFireFlameSimple,
  font: faFont,
  gear: faGear,
  gem: faGem,
  hand: faHand,
  handshake: faHandshake,
  hashtag: faHashtag,
  hatCowboy: faHatCowboy,
  heart: faHeart,
  hourglass: faHourglass,
  hourglassEnd: faHourglassEnd,
  hourglassHalf: faHourglassHalf,
  hourglassStart: faHourglassStart,
  house: faHouse,
  image: faImage,
  infinity: faInfinity,
  instagram: faInstagram,
  landmark: faLandmark,
  link: faLink,
  listCheck: faListCheck,
  lock: faLock,
  m: faM,
  magnifyingGlass: faMagnifyingGlass,
  minus: faMinus,
  moneyBillWave: faMoneyBillWave,
  moon: faMoon,
  newspaper: faNewspaper,
  paperclip: faPaperclip,
  patreon: faPatreon,
  peopleArrows: faPeopleArrows,
  percent: faPercent,
  plus: faPlus,
  podcast: faPodcast,
  question: faQuestion,
  r: faR,
  random: faRandom,
  rotateLeft: faRotateLeft,
  rotateRight: faRotateRight,
  route: faRoute,
  rss: faRssSquare,
  s: faS,
  sackDollar: faSackDollar,
  scroll: faScroll,
  search: faSearch,
  shirt: faShirt,
  skullCrossbones: faSkullCrossbones,
  squareMinus: faSquareMinus,
  squarePlus: faSquarePlus,
  star: faStar,
  stethoscope: faStethoscope,
  stopwatch: faStopwatch,
  sun: faSun,
  table: faTable,
  tableCellsLarge: faTableCellsLarge,
  tableList: faTableList,
  tag: faTag,
  thumbsUp: faThumbsUp,
  tiktok: faTiktok,
  times: faTimes,
  trash: faTrash,
  twitch: faTwitch,
  u: faU,
  unlock: faUnlock,
  user: faUser,
  wandMagicSparkles: faWandMagicSparkles,
  wrench: faWrench,
  xMark: faXmark,
  youtube: faYoutube,
}

export type EDHRECIconsType = keyof typeof EDHREC_ICONS

type Props = {
  icon: EDHRECIconsType
} & Omit<FontAwesomeIconProps, 'icon'>

const Icon: React.FC<Props> = (props: Props) => <FontAwesomeIcon {...props} icon={EDHREC_ICONS[props.icon]} />

export default Icon
